export default __webpack_public_path__ + "static/media/lupa.6df58690.svg";